<template>
  <section class="main">
    <div class="main__filters">
      <h2 class="main__filters-title">
        <img src="@/assets/icon-search.svg" />
        {{ $t("HOME_FILTERS_TITLE") }}
      </h2>

      <universal-filters v-model="filters" :initial-filters="initialFilters" save-to-url />
    </div>
    <div class="main__content">
      <universal-search hide-filters :filters="filters" @update:filters="filters = $event" />
    </div>
    <sidebar class="main__sidebar" />
  </section>
</template>

<script>
import Sidebar from '@/components/HomeSidebar';
import UniversalSearch from '@/components/UniversalSearch/UniversalSearch.vue';
import { mapGetters } from 'vuex';
import UniversalFilters from '../components/UniversalSearch/UniversalFilters.vue';

export default {
  name: 'home',
  components: {
    Sidebar,
    UniversalSearch,
    UniversalFilters,
  },
  data() {
    return {
      filters: {},
    };
  },
  computed: {
    title() {
      return this.$t('SITE_TITLE');
    },
    ...mapGetters(['currentDeviceOS']),
    initialFilters() {
      if (!this.currentDeviceOS) {
        return {};
      }

      return {
        compatibility: this.currentDeviceOS,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;

  @include notebook {
    flex-direction: column;
  }

  &__filters {
    width: 100%;

    @include notebook {
      order: 1;
    }
  }

  &__filters-title {
    display: flex;
    gap: 6px;
    align-items: center;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 600;

    @include notebook {
      font-size: 18px;
      margin-bottom: 12px;
    }

    img {
      height: 15px;
      margin-top: 2px;

      @include notebook {
        height: 17px;
      }
    }
  }

  &__content {
    flex-grow: 1;
    max-width: 100%;

    @include notebook {
      order: 2;
    }
  }

  &__sidebar {
    width: 370px;

    @include notebook {
      width: 100%;
      order: 0;
    }
  }

  &__apps {
    &:not(:last-child) {
      margin-bottom: 40px;

      @include notebook {
        margin-bottom: 30px;
      }
    }
  }
}
</style>
